<!--
 * @title: 页面名称
 * @Description: 
 * @Version: 2.0
 * @Autor: 研发三部
 * @Date: 2020-12-03 09:37:11
 * @LastEditors: wch
 * @LastEditTime: 2020-12-28 16:01:28
-->
<template>
    <div class="home_view" style="width: 100%; height: 100%">
        <!-- <dv-full-screen-container> -->

        <div style="width: 100%; height: 100%" v-if="this.$route.name == 'terminal-configuration'">
            <el-carousel :interval="5000" arrow="always" style="width: 100%;height: 100%">
                <el-carousel-item v-if="shouyeBackdropImage && shouyeBackdropImage.length > 0"
                    v-for="item in shouyeBackdropImage" style="width: 100%; height: 100%">
                    <el-image :src="item.url" style="width: 100%; height: 100%"></el-image>


                </el-carousel-item>

                <el-carousel-item v-if="!shouyeBackdropImage || shouyeBackdropImage.length == 0"
                    style="width: 100%; height: 100%">
                    <el-image style="width: 100%; height: 100%">
                        <div slot="error" class="image-slot1">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </el-carousel-item>




                <div class="carousel__icon">
                    <!-- display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr;gap: 5%; -->
                    <div style="width: 100%;justify-content: center;display: flex;">
                        

                        <div @click="skipUrl(item)"
                            style="cursor: pointer;"
                            v-if="item.status == 1" v-for="item in shouyeIcon" class="icon_box">
                            <div class="icon_box1">

                                <el-image v-if="item.icon" style="width: 58px;height: 58px;" :src=" item.icon" fit="fit"
                                    ></el-image>
                                <el-image style="width: 58px;height: 58px;" v-else>
                                    <div slot="error" class="image-slot2">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                                <div class="text_center_1" style="">{{
                                    item.name
                                }}</div>

                            </div>

                        </div>
                    
                </div>

                </div>
            </el-carousel>


        </div>
        <div style="width: 100%; height: 100%" v-else>
            <el-carousel :interval="5000" arrow="always" style="width: 100%;height: 100%">
                <el-carousel-item v-if="shouyeBackdropImage1 && shouyeBackdropImage1.length > 0"
                    v-for="item in shouyeBackdropImage1" style="width: 100%; height: 100%">
                    <el-image class="imageBox11" :src="item.url" fit="fit" style="width: 100%; height: 100%"></el-image>
                    <!-- <div style="position: absolute;top: 10%;left:  40%;color: red;font-size: 1.5vw;" class="image_title">  h:{{ h }};w:{{ w
}}</div> -->

                </el-carousel-item>

                <el-carousel-item v-if="!shouyeBackdropImage1 || shouyeBackdropImage1.length == 0"
                    style="width: 100%; height: 100%">
                    <el-image style="width: 100%; height: 100%">
                        <div slot="error" class="image-slot1">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </el-carousel-item>




                <div class="carousel__icon">
                    <!-- display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr;gap: 5%; -->
                    <div style="width: 100%;justify-content: center;display: flex;">
                        

                            <div @click="skipUrl(item)"
                                style="cursor: pointer;"
                                v-if="item.status == 1" v-for="item in shouyeIcon1" class="icon_box">
                                <div class="icon_box1">

                                    <el-image v-if="item.icon" style="width: 58px;height: 58px;" :src=" item.icon" fit="fit"
                                        ></el-image>
                                    <el-image style="width: 58px;height: 58px;" v-else>
                                        <div slot="error" class="image-slot2">
                                            <i class="el-icon-picture-outline"></i>
                                        </div>
                                    </el-image>
                                    <div class="text_center_1" style="">{{
                                        item.name
                                    }}</div>

                                </div>

                            </div>
                        
                    </div>

                </div>
            </el-carousel>


        </div>

        <el-dialog :visible.sync="dialogVisible" width="25%" ref="qrcodeDialog" :before-close="handleClose">
            <div ref="qrcode" style="margin:0 auto;"></div>
            <div style="text-align: center;color: red;margin-top: 10px;">该设备未绑定,请扫描二维码</div>
        </el-dialog>


        <!-- </dv-full-screen-container> -->

    </div>
</template>
<script>

import * as api from "@/api/cloud-screen";
import CFG from "@/config/config";

import QRCode from 'qrcodejs2'



export default {
    components: {

    },
    props: {
        shouyeBackdropImage: {
            type: Array, default: function () {
                return [] // 或者[]
            }
        },
        shouyeIcon: {
            type: Array, default: function () {
                return [] // 或者[]
            }
        },

    },
    data() {
        return {
            w: 0,
            h: 0,
            urlprefix: CFG.LOTIP,
            fileList3: [
                {
                    name: "高原鼢鼠",
                    url:
                        "/large-screen/icon/1.jpg",
                },
                {
                    name: "高原属兔",
                    url:
                        "/large-screen/icon/2.jpeg",
                },
                {
                    name: "青海田鼠",
                    url:
                        "/large-screen/icon/3.jpg",
                },
                {
                    name: "青海田鼠",
                    url:
                        "/large-screen/icon/4.jpg",
                },
                {
                    name: "青海田鼠",
                    url:
                        "/large-screen/icon/5.jpeg",
                },

            ],
            shouyeBackdropImage1: [],
            shouyeIcon1: [],
            dialogVisible: false,
            qrcode: null,
            timerId: null,
            count: 0, // 用于计数的数据属性
            icon_box_width: ''
        };
    },
    watch: {},
    async mounted() {
        // setInterval(() => {
        //     this.getH()
        //     this.getW()
            
        // }, 5000);
        if (this.$route.name == 'homeView' || this.$route.name == 'cloudScreen') {
            let device = await api.getByDevice(this.$route.params.systemSid);
            if (device.resp_code == "10000") {
                if (!device.data) {
                    this.dialogVisible = true
                    this.generateQRCode()
                    this.timerId = setInterval(async () => {
                        let device = await api.getByDevice(this.$route.params.systemSid);
                        if (device.data) {
                            clearInterval(this.timerId);
                            this.dialogVisible = false
                            location.reload();
                        }
                    }, 5000);
                } else {
                    this.getTemp()
                }
            }
        }


    },
    methods: {
        getW() {
            this.w = document.getElementsByClassName('imageBox11')[0].clientWidth
        },

        getH() {
            this.h = document.getElementsByClassName('imageBox11')[0].clientHeight
        },
        generateQRCode() {
            this.$nextTick(item => {
                if (this.qrcode != null) {
                    this.qrcode.clear() // 清除原来的二维码
                }
                console.log(this.$refs.qrcodeDialog)
                console.log(this.$refs.qrcode)
                this.qrcode = new QRCode(this.$refs['qrcode'], {
                   
                    text: this.$route.params.systemSid
                })

            })

        },
        handleClose() {
            this.dialogVisible = false

        },
        sortKey(array, key) {
            return array.sort(function (a, b) {
                var x = a[key];
                var y = b[key];
                return ((x < y) ? -1 : (x > y) ? 1 : 0)
            })
        },
        getTemp() {
            this.shouyeBackdropImage1 = []

            api.getTemp(this.$route.params.systemSid).then(res => {
                if (res.resp_code == "10000") {
                    console.log(res.data, "==================")

                    if (res.data) {
                        let arr = []
                        let obj1 = { name: "草原一张图", url: "/large-screen/" + this.$route.params.systemSid, status: 0, icon: '/large-screen/icon/cy.png', sort: 1, type: 'system' }
                        let obj2 = { name: "自定义", url: '', status: 0, icon: '', sort: 2, type: 'costom' }
                        let obj3 = { name: "自定义", url: '', status: 0, icon: '', sort: 3, type: 'costom' }
                        let obj4 = { name: "自定义", url: '', status: 0, icon: '', sort: 4, type: 'costom' }
                        let obj5 = { name: "自定义", url: '', status: 0, icon: '', sort: 5, type: 'costom' }
                        this.temp = res.data
                        if (res.data) {

                            if (res.data.shouyeIcon) {
                                arr = JSON.parse(res.data.shouyeIcon)
                            } else {
                                arr.push(obj1)
                                arr.push(obj2)
                                arr.push(obj3)
                                arr.push(obj4)
                                arr.push(obj5)
                            }

                            if (res.data.shouyeBackdropImage) {
                                this.shouyeBackdropImage1 = JSON.parse(res.data.shouyeBackdropImage)
                            } else {
                                this.shouyeBackdropImage1 = []
                            }


                        } else {
                            arr.push(obj1)
                            arr.push(obj2)
                            arr.push(obj3)
                            arr.push(obj4)
                            arr.push(obj5)
                            this.shouyeBackdropImage1 = []
                        }
                        this.shouyeIcon1 = this.sortKey(arr, 'sort')
                    }
                }
            });
        },


        skipUrl(item) {

            if (item.url) {
                if (item.type == 'system') {
                    this.$router.push(item.url+this.$route.params.systemSid)
                }else {
                    this.$router.push({path:"/external-resource-view/"+this.$route.params.systemSid,query:item})
                    // window.open(item.url, "_blank");
                }

            } else {
                this.$message.info("该图标未绑定资源！")
            }

        },

        // skipUrl(url) {
        //     if (url) {
        //         window.open(url, "_blank");
        //     } else {
        //         this.$message.info("该图标未绑定资源！")
        //     }

        // },
        changeActiveComponents(val) {
            //修改父组件传来的值
            this.$emit("changeActiveComponents", val);
        },

        getPestData(ids) {
            api.getPestData(ids).then((res) => {
                if (res.resp_code == "10000") {
                    let obj = res.data
                    this.fileList = obj['鼠害']
                    this.fileList1 = obj['虫害']
                    this.fileList2 = obj['毒害草']
                }
            });



        },

        getAreaAndType() {
            api.getAreaAndType(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.areaAndType.grasslandArea = res.data.grasslandArea
                        ? res.data.grasslandArea
                        : "-";
                    this.areaAndType.grasslandType = res.data.grasslandType
                        ? res.data.grasslandType
                        : "-";
                    this.areaAndType.rangeland = res.data.rangeland ? res.data.rangeland : "-";
                }
            });
        },
        getRangelandChart() {
            api.getRangelandChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.rangelandChart.xAxis.data = res.data.x;
                    this.rangelandChart.series.data = res.data.y;
                }
            });
        },
        getTypeChart() {
            api.getTypeChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.typeChart.xAxis.data = res.data.x;
                    this.typeChart.series.data = res.data.y;
                }
            });
        },
        getGrasslandGradeChart() {
            api.getGrasslandGradeChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.grasslandGradeChart.category = res.data.x;
                    this.grasslandGradeChart.lineData = res.data.y;
                }
            });
        },
        getGrasslandClassChart() {
            api.getGrasslandClassChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.grasslandClassChart.xAxis.data = res.data.x;
                    this.grasslandClassChart.series.data = res.data.y;
                }
            });
        },

        // getDegradationChart() {
        //   api.getDegradationChart(this.$route.params.systemSid).then((res) => {
        //     if (res.resp_code == "10000") {
        //       console.log(res.data,"pppppppppppppppp")
        //       this.grasslandClassChart.category = res.data.x;
        //       this.grasslandClassChart.lineData = res.data.y;
        //       this.degradationArea=res.data.area.sum
        //     }
        //   });
        // },

        getDegradationChart() {
            api.getDegradationChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    // this.degradationChart.xData = res.data.legend;
                    this.degradationChart.series[0].data = res.data.data;
                    this.degradationArea = res.data.area ? res.data.area.sum.toFixed(2) : "-";
                }
            });
        },

        getVegetationCoverageChart() {
            api.getVegetationCoverageChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.vegetationCoverageChart.xAxis.data = res.data.x;
                    this.vegetationCoverageChart.series.data = res.data.y;
                    this.avgCoverage = res.data.avgCoverage
                        ? res.data.avgCoverage.avgCoverage.toFixed(2)
                        : "-";
                }
            });
        },
    },
};
</script>
  
<style lang="scss" scoped>
.text_center_1 {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #fff;
    margin-top: 18px;
}

.icon_box1 {
    position: relative;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    display: flex;
}

.icon_box {
    height: 100px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    color: #fff;
    cursor: pointer;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-right: 5%;
    // border: 1px red solid;
}

.carousel__icon .icon_box:nth-last-child(1) {
    margin-right: 0% !important;
}

.carousel__icon {
    position: absolute;
    bottom: 40px;
    z-index: 99;
    width: 100%;
    background: rgba(0, 0, 0, .4);
    padding: 10px 0 10px;
}

.home_view /deep/ .el-carousel__indicators--horizontal{
    display: none;
}

.home_view /deep/ .el-carousel__container {
    height: 100%;
    width: 100%;

}

.home_view /deep/ .el-carousel__arrow--left {
    left: 165px;
}

.home_view /deep/ .el-carousel__arrow--right {
    right: 180px;
}

.home_view /deep/ .el-carousel__arrow{
    width: 54px;
    height: 54px;
    background-color: rgba(0,0,0,.4);
    font-size: 2vw;
    font-weight: 800;
}
</style>

<style>
.image-slot1 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #d7dde7;
    font-size: 14px;
    font-size: 12vw;
}

.image-slot2 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #d7dde7;
    font-size: 14px;
    font-size: 2vw;
}
</style>
  